import BannerManagement from "./banner-management.page";

export default BannerManagement;
